module.exports = __webpack_public_path__ + "static/23-tat2A-478eb8c4b458a4ca72abef7d360d1487.jpg";